import { getName } from "@/global";
import { ExternalRegisterDot } from "@/components/externalregister/ExternalRegisterDot";
import { getPatientExternalRegisterAlerts, type PatientEncounterWithExternalRegisterSummary } from "@/components/externalregister/patientSummary";
import { useConciergeMode } from "@/contexts/ConciergeModeContext";
import { useSettingsContext } from "@/pages/settings/SettingsProvider";
import { PatientEncounter } from "@/resources/types";
import MobileFriendlyOutlinedIcon from "@mui/icons-material/MobileFriendlyOutlined";
import { Stack } from "@mui/material";
import { GridRenderCellParams, GridValueGetter } from "@mui/x-data-grid";
import PatientName from "./Patient/PatientName";
import { canRenderExternalRegisterDotIndicator } from "@/util/externalRegister";

export const getFullNameValue: GridValueGetter = (_, row) => {
  const nameInfo = getName(row as PatientEncounter);
  return nameInfo.fromPatient || nameInfo.fromDelegate || "-";
};

const FullNameCellContent = ({ params }: { params: GridRenderCellParams }) => {
  const patient = params.row as PatientEncounter;
  const row = params.row as PatientEncounterWithExternalRegisterSummary;
  const { isConciergeMode } = useConciergeMode();
  const { settings } = useSettingsContext();
  const showExternalRegisterDot = canRenderExternalRegisterDotIndicator({
    isConciergeMode,
    settings,
  });
  const externalRegisterAlerts = getPatientExternalRegisterAlerts(row.patient);
  // Show phone icon for encounters created via mobile app
  // - source === "patient" for self-registered encounters
  // - source === "delegate-mobile" for delegate encounters created via mobile app
  const isMobileAppEncounter = patient.source === "patient" || patient.source === "delegate-mobile";

  return (
    <Stack flexDirection="row" justifyContent="space-between" alignItems="center" width="100%" gap={1}>
      <Stack flexDirection="row" alignItems="center" gap={0.75} minWidth={0}>
        <PatientName encounter={patient} />
        {showExternalRegisterDot ? (
          <ExternalRegisterDot alerts={externalRegisterAlerts} />
        ) : null}
      </Stack>
      {isMobileAppEncounter && <MobileFriendlyOutlinedIcon />}
    </Stack>
  );
};

export const FullNameCell = (params: GridRenderCellParams) => {
  return <FullNameCellContent params={params} />;
};
